import { setExpressListAction, ActionType } from './index'
import { takeEvery, put, all, fork } from 'redux-saga/effects'
import { GET_EXPRESSCOMPANY_LIST } from '../../api/orderManage'
import { expressType } from '../../tools/state'
import { isResponseCodeSuccess } from '../../tools/util'

function* alltask() {
  yield takeEvery<ActionType>('getExpressListAction', getExpressList)
}

// 物流
function* getExpressList(): any {
  const res = yield GET_EXPRESSCOMPANY_LIST({
    type: expressType,
  })
  if (isResponseCodeSuccess(res.code)) {
    yield put(setExpressListAction(res.data))
  }
}

// 导出当前模块的saga处理方法
export default function* sagas() {
  yield all([fork(alltask)])
}
import { setExpressListAction, ActionType } from './index'
import { takeEvery, put, all, fork } from 'redux-saga/effects'
import { GET_EXPRESSCOMPANY_LIST } from '../../api/orderManage'
import { expressType } from '../../tools/state'
import { isResponseCodeSuccess } from '../../tools/util'

function* alltask() {
  yield takeEvery<ActionType>('getExpressListAction', getExpressList)
}

// 物流
function* getExpressList(): any {
  const res = yield GET_EXPRESSCOMPANY_LIST({
    type: expressType,
  })
  if (isResponseCodeSuccess(res.code)) {
    yield put(setExpressListAction(res.data))
  }
}

// 导出当前模块的saga处理方法
export default function* sagas() {
  yield all([fork(alltask)])
}
